import { useState } from "react";
import {useHistory} from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import {ChatState} from "../../Context/ChatProvider";
import {clearAttempts, CLIENT_LOCK_DURATION_MS, incrementAttempts, isClientLocked, LOCK_TIME_KEY, MAX_CLIENT_ATTEMPTS} from "../../utils/AuthProtectionFunctions";

const Login = (props) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading ] = useState(false);
    const [blocked, setBlocked ] = useState(false);
    const history = useHistory();
    const { setCsrfToken, showToast,  updateUser, setOpenAvatar } = ChatState();
    const submitHandler = async (e) => {
        if(loading) return;
        e.preventDefault();
        setLoading(true);
        const lockStatus = isClientLocked();
        if (lockStatus.isLocked) {
            setLoading(false);
            showToast('danger', `Too many attempts. Try in  ${Math.ceil(lockStatus.remaining / 60)} minutes.`);
            setBlocked(true);   
            setTimeout(() => {
                setBlocked(false);
            }, Math.ceil(lockStatus.remaining * 1000) );
            return; 
        }

        if (!email || !password) {
            showToast ( 'warning', 'Please fill all the fields');
            setLoading(false);
            return;
        }

        const sanitizedEmail = email.replace(/[<>&]/g, '');
        const sanitizedPassword = password.replace(/[<>&]/g, '');
        if (sanitizedEmail !== email || sanitizedPassword !== password) {
            showToast('warning', 'Invalid credentials.');
            setLoading(false);
            return;
        }
        setEmail(sanitizedEmail);
        setPassword(sanitizedPassword);
        try {
            const config = {
                headers: {"Content-type": "application/json" },
                withCredentials: true
            };
            const { data } = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/user/login`,
                { email, password},
                config
            );
            showToast ( 'success', 'Login successfull!' );
            if (data.email === 'guest@example.com') {
                showToast ( 'info', 'The guest session lasts 10 minutes. Please be careful.' );
            }
            localStorage.setItem("userInfo", JSON.stringify(data));
            updateUser(data);
            setCsrfToken(data.csrfToken);
            setLoading(false);
            history.push("/chats");
            if (data.email === 'guest@example.com') {
                setTimeout(() => {
                    showToast ( 'info', 'Guest session ends in 20s. Create your own profile.' );
                    setTimeout(() => {
                        showToast ( 'info', 'Guest session has ended.' );
                        logoutHandler(); 
                    }, 20000);
                }, 300000);
            }
            setBlocked(false);
            setOpenAvatar(false);
            clearAttempts();
        } catch (error) {
            const newAttempts = incrementAttempts();
            if (newAttempts >= MAX_CLIENT_ATTEMPTS) {
                const lockTime = Date.now() + CLIENT_LOCK_DURATION_MS;
                localStorage.setItem(LOCK_TIME_KEY, lockTime);
                showToast('danger', 'Too many attempts, account blocked for several minutes');
                setBlocked(true);   
                setTimeout(() => {
                    setBlocked(false); 
                }, lockStatus.remaining * 1000);
            } else {
                console.error("Full error object:", error);
                showToast('danger', 'Wrong login. Attempts left:  ' + (MAX_CLIENT_ATTEMPTS - newAttempts));
            }
            if (error.response) {
                console.log("Status:", error.response.status);
            } else {
                console.log("Error message:", error.message);
            }
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
    // there is 2 functions. Need only one
    const logoutHandler = async () => {  
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/user/logout`);
        } catch (error) {
            console.error("LogOut error:", error.message);
        } finally {
            updateUser(null);
            localStorage.removeItem("userInfo");
            history.push("/");
        }
    };

    return (
            <div >
                <h1 className='display1'>
                    <b> Login</b>
                </h1>
                <form onSubmit={submitHandler}>
                    <div className='form-group'>
                        <label className='label p-2'>
                            <span className='text-base text-white'>Username</span>
                        </label>
                        <input
                            type='text'
                            placeholder='Enter Email-username'
                            className='updateInput'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className='label'>
                            <span className='text-base text-white'>Password</span>
                        </label>
                        <input
                            type='password'
                            placeholder='Enter Password'
                            className='updateInput'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <button onClick={()=>props.setLoginSignup(false)}  className='link_account'>
                        {"Don't"} have an account?
                    </button>
                    <div className='login_buttons'>
                        <button className=' button signup_button' disabled={loading || blocked} type="submit"    style={{opacity: `${blocked  ? '0.2' : '1' }`}}  >  
                            {loading ? <span className='loading loading-spinner '></span> : "Login"}
                        </button>
                        <button
                            className=' button'
                            variant="solid"
                            onClick={() => {
                                setEmail("guest@example.com");
                                setPassword("12345678");
                            }}
                        >
                            Guest
                        </button>
                    </div>
                </form>
            </div>
    );
};
export default Login;